/**
 * @param dataWrapper {ReturnType<import('core/data/data-wrapper')._DB>}
 */
export function createInvestmentRepository(dataWrapper) {
  const INVESTMENT_FUND_DOCUMENT_KEY = 'investment_fund'
  const PRODUCT_DOCUMENT_KEY = 'product'
  const { list, get } = dataWrapper

  const _listInvestmentFunds = (list) => list(INVESTMENT_FUND_DOCUMENT_KEY)

  const listInvestmentFunds = () => _listInvestmentFunds(list)

  const listCoiRates = () => _listCoiRates(list)

  const _listCoiRates = (list) => list('coi-rate')

  const listCorRates = () => _listCorRates(list)

  const _listCorRates = (list) => list('cor-rate')

  const _getInvestmentFund = (get, code) => get(`${INVESTMENT_FUND_DOCUMENT_KEY}_${code}`)

  const getInvestmentFund = (code) => _getInvestmentFund(get, code)

  const _getInvestmentProductConfiguration = (code, get) => get(`${PRODUCT_DOCUMENT_KEY}_${code}`)

  const getInvestmentProductConfiguration = (query) => _getInvestmentProductConfiguration(query.code, get)

  const _getInvestmentFundLimits = (query, getRpulProductConfiguration) => {
    return getRpulProductConfiguration(query).then((product) => product.fundAllocationLimits)
  }

  const getInvestmentFundLimits = (query) => {
    return _getInvestmentFundLimits(query, getInvestmentProductConfiguration)
  }

  return {
    _listInvestmentFunds,
    listInvestmentFunds,
    listCoiRates,
    _listCoiRates,
    listCorRates,
    _listCorRates,
    _getInvestmentFund,
    getInvestmentFund,
    _getInvestmentProductConfiguration,
    getInvestmentProductConfiguration,
    _getInvestmentFundLimits,
    getInvestmentFundLimits,
  }
}
